// مولّدات HTML للطباعة على 80mm (محتوى 78mm) — أسود بالكامل، بدون أي تصغير تلقائي.
// يشمل:
// 1) buildInvoiceHtml  → فاتورة كاملة (اسم المنتج يلتفّ طبيعيًا + أحجام متناسقة)
// 2) buildPicklistHtml → قائمة تجهيز (اسم + كمية) بجدول مركّز

function esc(s) {
  return String(s ?? "").replace(
    /[<>]/g,
    (m) => ({ "<": "&lt;", ">": "&gt;" }[m])
  );
}

function commonHead({ pageWidthMm, pageHeightMm, contentWidthMm, title }) {
  const pageSize = pageHeightMm
    ? `${pageWidthMm}mm ${pageHeightMm}mm`
    : `${pageWidthMm}mm auto`;

  return `<!doctype html>
<html dir="rtl" lang="ar">
<meta charset="utf-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>${esc(title || "")}</title>
<style>
  /* =============== إعدادات عامة للطباعة =============== */
  html, body {
    margin: 0; padding: 0;
    -webkit-print-color-adjust: exact; print-color-adjust: exact;
    color: #000; background: #fff;
  }
  * { box-sizing: border-box; }
  @page { size: ${pageSize}; margin: 0; }

  body {
    width: ${contentWidthMm}mm; /* محتوى داخل ورقة 80mm لمنع القص */
    margin: 0 auto;
    font-family:
      "Tahoma", "Segoe UI", system-ui, -apple-system, Roboto, Helvetica, Arial,
      "Noto Naskh Arabic", "Noto Kufi Arabic", "Amiri", sans-serif;
    font-size: 12.5px;
    line-height: 1.5;
    font-variant-numeric: tabular-nums; /* أرقام ثابتة العرض */
    color: #000;
  }

  /* مساحات آمنة حتى لا تلتصق الطباعة بالحواف */
  .wrap { padding: 10px 8px; }

  /* بطاقة/إطار داخلي مركّز لمنع الاقتراب من الزوايا */
  .card {
    border: 2px solid #000;
    border-radius: 1.2mm;
    padding: 3mm 3mm 2.5mm;
    margin: 2mm auto 0;
    width: calc(100% - 6mm); /* يترك هوامش واضحة يمين/يسار */
  }

  .title {
    text-align: center;
    font-weight: 900;
    font-size: 16px;
    color: #000;
    letter-spacing: .2px;
    margin-top: 2px;
  }

  .meta {
    text-align: center;
    font-size: 12px;
    color: #000;
    margin-top: 2px;
  }
  .meta .no { margin-top: 2px; font-weight: 800; color: #000; }

  .hr   { border-top: 2px solid #000; margin: 7px 0; }
  .line { border-top: 1px solid #000; margin: 6px 0; }

  /* =============== جدول عام =============== */
  table {
    width: 96%;
    margin: 0 auto;
    border-collapse: collapse;
    table-layout: fixed;
    margin-top: 6px;
  }

  thead th {
    font-size: 12px;
    font-weight: 900;
    color: #000;
    padding: 6px 4px;
    border-top: 2px solid #000;
    border-bottom: 2px solid #000;
    text-align: center;
  }

  tbody td {
    padding: 6px 4px;
    border-bottom: 1px solid #000;
    color: #000;
    font-weight: 700;
    vertical-align: middle; /* يجعل الأعمدة الرقمية وسط الصف عند التفاف الاسم */
  }

  /* توزيع عرض الأعمدة لثبات التخطيط */
  td.name  { width: 50%; } /* مساحة أكبر للاسم كي لا يلفّ كل كلمة بسطر */
  td.qty   { width: 12%; text-align: center; font-size: 11.5px; }
  td.price { width: 19%; text-align: left;  direction: ltr; font-size: 11.5px; }
  td.sum   { width: 19%; text-align: left;  direction: ltr; font-size: 11.5px; }

  /* اسم المنتج: التفاف طبيعي + بدون تكسير مبالغ فيه */
  td.name .nm {
    display: block;
    max-width: 100%;
    white-space: normal;          /* يسمح بالالتفاف لسطر/سطرين/أكثر */
    word-break: normal;           /* لا يكسر داخل الكلمات إلا للضرورة */
    overflow-wrap: break-word;    /* يكسر فقط عند الكلمات الطويلة جداً */
    direction: rtl;               /* تأكيد RTL */
    font-weight: 800;
    font-size: 11.5px;            /* أصغر قليلاً كما طلبت */
    line-height: 1.35;
  }

  /* جدول شبكة (قائمة التجهيز): حدود كاملة لكل خلية */
  .grid th, .grid td { border: 1.2px solid #000; }
  .grid thead th { border-bottom-width: 1.8px; }

  .mono  { direction: ltr; }
  .center{ text-align: center; }
  .left  { text-align: left;  }
  .right { text-align: right; }

  .totals { margin-top: 6px; }
  .row { display: flex; justify-content: space-between; margin: 3px 0; font-size: 12.5px; }
  .row .label { color: #000; font-weight: 800; }
  .row .val   { color: #000; font-weight: 900; }
  .row .val.mono { direction: ltr; }

  .total-sep { border-top: 2px solid #000; margin: 7px 0 5px; }

  .foot { text-align: center; font-size: 12px; color: #000; margin-top: 9px; font-weight: 800; }

  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
</style>`;
}

/* ======================= 1) الفاتورة الكاملة (الطابعة الأولى) ======================= */
export function buildInvoiceHtml({
  invoiceNo,
  lines = [],
  subtotal = 0,
  discount = 0,
  total = 0,
  customerName = "",
  printedAt = new Date(),
  pageHeightMm = null,
  contentWidthMm = 78,
}) {
  const pageWidthMm = 80;
  const fmt = (n) => Number(n || 0).toLocaleString("en-EG");
  const dateStr = new Date(printedAt).toLocaleString("ar-IQ");

  const rows = lines
    .map(
      (l) => `
      <tr>
        <td class="name right"><span class="nm">${esc(
          l?.name ?? "-"
        )}</span></td>
        <td class="qty center mono">${l?.qty ?? 0}</td>
        <td class="price left mono">${fmt(l?.price)}</td>
        <td class="sum left mono">${fmt((l?.price || 0) * (l?.qty || 0))}</td>
      </tr>`
    )
    .join("");

  const head = commonHead({
    pageWidthMm,
    pageHeightMm,
    contentWidthMm,
    title: `فاتورة ${invoiceNo ?? ""}`,
  });

  return `${head}
<body>
  <div class="wrap">
    <div class="card">
      <div class="title">فاتورة بيع</div>
      <div class="meta">
        ${invoiceNo ? `<div class="no">رقم: ${esc(invoiceNo)}</div>` : ""}
        <div>تاريخ: ${esc(dateStr)}</div>
        <div>الزبون: ${esc(customerName || "-")}</div>
      </div>

      <div class="hr"></div>

      <table>
        <thead>
          <tr>
            <th class="right">المنتج</th>
            <th class="center">كمية</th>
            <th class="center">سعر</th>
            <th class="center">المجموع</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>

      <div class="total-sep"></div>
      <div class="totals">
        <div class="row">
          <span class="label">المجموع</span>
          <span class="val mono">${fmt(subtotal)} د.ع</span>
        </div>
        <div class="row">
          <span class="label">الخصم (%)</span>
          <span class="val mono">${discount}</span>
        </div>
        <div class="row">
          <span class="label">الإجمالي</span>
          <span class="val mono">${fmt(total)} د.ع</span>
        </div>
      </div>

      <div class="foot">شكراً لكم</div>
    </div>
  </div>
</body>
</html>`;
}

/* ======================= 2) قائمة تجهيز مختصرة (الطابعة الثانية) ======================= */
/* — جدول بحدود كاملة + محتوى مركّز داخل بطاقة — */
export function buildPicklistHtml({
  invoiceNo,
  lines = [],
  customerName = "",
  printedAt = new Date(),
  pageHeightMm = null,
  contentWidthMm = 78,
}) {
  const pageWidthMm = 80;
  const dateStr = new Date(printedAt).toLocaleString("ar-IQ");

  const rows = lines
    .map(
      (l) => `
      <tr>
        <td class="center">${esc(l?.name ?? "-")}</td>
        <td class="center mono">${l?.qty ?? 0}</td>
      </tr>`
    )
    .join("");

  const head = commonHead({
    pageWidthMm,
    pageHeightMm,
    contentWidthMm,
    title: `قائمة تجهيز ${invoiceNo ?? ""}`,
  });

  return `${head}
<body>
  <div class="wrap">
    <div class="card">
      <div class="title">قائمة تجهيز</div>
      <div class="meta">
        ${invoiceNo ? `<div class="no">رقم: ${esc(invoiceNo)}</div>` : ""}
        <div>تاريخ: ${esc(dateStr)}</div>
        ${customerName ? `<div>الزبون: ${esc(customerName)}</div>` : ""}
      </div>

      <div class="hr"></div>

      <table class="grid">
        <thead>
          <tr>
            <th class="center">المادة</th>
            <th class="center">الكمية</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>

      <div class="foot">— للاعتماد والتجهيز —</div>
    </div>
  </div>
</body>
</html>`;
}
